<template>
  <!-- <HelloWorld /> -->
    <SignIn />
</template>

<script>
//import HelloWorld from '../components/HelloWorld';
import SignIn from '../components/SignIn';

export default {
  components: {
    //HelloWorld,
    SignIn
  },
};
</script>
